import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';

import { FormService } from './_services/form.service';
import { ThreeService } from './_services/three.service';
import { NotificationService } from './_services/notification.service';
import { TranslateService } from './_services/translate.service';
import { TranslatePipe } from './pipes/translate.pipe';
import { ScriptLoaderService } from './_services/script-loader.service';
import { CartService } from './_services/cart.service';

import { CapsLockDirective } from './capslock.directive';
import { AppPasswordDirective } from './app-password.directive';
import { DndDirective } from './dnd.directive';

export function setupTranslateFactory(service: TranslateService): Function {
    return () => service.setDefaultLanguage();
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        AgmCoreModule.forRoot({
            apiKey: "AIzaSyC4dARqJQTzZKb-1YH8i1dvuijbAzNgZOk",
            libraries: ["places"]
        })
    ],
    declarations: [
        TranslatePipe,
        CapsLockDirective,
        AppPasswordDirective,
        DndDirective
    ],
    exports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe,
        CapsLockDirective,
        AppPasswordDirective,
        DndDirective
    ]
})
export class SharedModule {
    static forRoot() {
        return {
            ngModule: SharedModule,
            providers: [
                FormService,
                NotificationService,
                ThreeService,
                ScriptLoaderService,
                TranslateService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: setupTranslateFactory,
                    deps: [TranslateService],
                    multi: true
                },
                TranslatePipe,
                CartService,
                { provide: 'BASE_URL', useFactory: getBaseUrl }
            ]
        }
    }
}

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}


// WEBPACK FOOTER //
// ./ClientApp/app/shared.module.ts